// filter dropdown
const filteredList = document.querySelector('.downloads-block__list');
const unfilteredList = document.createElement('ul');
unfilteredList.style.display = 'none';
filteredList.after(unfilteredList);
const whitepapers = filteredList.querySelectorAll('.downloads-block__item');
const filterDropdown = document.querySelectorAll('.filter-dropdown');
const whitepapersFilter = document.querySelector('#whitepapers-filter');

if (filterDropdown && whitepapersFilter) {
	filterDropdown.forEach((filter) => {
		let dropdownName = filter.getAttribute('data-dropdown-name');
		let currentFilter = filter.querySelector('.filter-dropdown__current');
		let currentFilterSlug = currentFilter.getAttribute('data-slug');
		let filterItems = filter.querySelectorAll('.menu-item');
		// add selected class
		filter.querySelector(`.menu-item[data-slug="${currentFilterSlug}"]`).classList.add('selected');
		// open menu and close menu if click outside filter el
		currentFilter.addEventListener('click', (event) => {
			filter.classList.add('active');
		});
		let filterListener = function(event) {
			closeFilterDropdown(event, filter, filterListener);
		}
		document.addEventListener('click', filterListener, true);
		// update dropdown with new selected filter and close menu
		filterItems.forEach((item) => {
			item.addEventListener('click', (event) => {
				let newFilterSlug = item.getAttribute('data-slug');
				let newFilterName = item.textContent;
				currentFilter.setAttribute('data-slug', newFilterSlug);
				currentFilter.querySelector('span').textContent = newFilterName;
				filter.querySelector('.menu-item.selected').classList.remove('selected');
				document.querySelector(`input[name="${dropdownName}"]`).value = newFilterSlug;
				item.classList.add('selected');
				filter.classList.remove('active');
				whitepapersFilterSubmit();
			});
		});
	});

	// filter whitepapers
	function whitepapersFilterSubmit() {
		let formData = new FormData(whitepapersFilter);
		let filteredSolution = formData.get('solution_category');
		let filteredCategory = formData.get('whitepaper_category');
		whitepapers.forEach((item) => {
			let filtered = false;
			let itemSolution = item.getAttribute('data-solution');
			let itemCategory = item.getAttribute('data-category');

			if (filteredSolution === 'all' && filteredCategory === 'all') {
				filtered = true;
			} else if (filteredSolution === 'all') {
				if (itemCategory === filteredCategory) {
					filtered = true;
				}
			} else if (filteredCategory === 'all') {
				if (itemSolution === filteredSolution) {
					filtered = true;
				}
			} else {
				if (itemSolution === filteredSolution && itemCategory === filteredCategory) {
					filtered = true;
				}
			}

			if (!filtered) {
				unfilteredList.append(item);
			} else {
				filteredList.append(item);
			}
		});

		// update filtered whitepapers index number
		filteredList.querySelectorAll('.downloads-block__item').forEach((item, i) => {
			let num = i + 1;
			item.querySelector('.downloads-block__item-num').textContent = num.toString().padStart(2, '0');
		});
	}
}

function closeFilterDropdown(event, filter, filterListener) {
	let targetEl = event.target;
	do {
		if (targetEl == filter) {
			// console.log('Clicked inside!');
			return;
		}
		// Go up the DOM
		targetEl = targetEl.parentNode;
	}
	while (targetEl);
	// console.log('Clicked outside!');
	filter.classList.remove('active');
	// document.removeEventListener('click', filterListener, true);
}
